// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "../css/default.scss";

require("./general");
require("../js/dropdown.js");
require("../js/forms.js");
require("../js/filters.js");
require("../js/mobile-filters.js");
require("../packs/page/load-more.js");

function defaultLayoutLogicInit() {
  const container = $('*[data-container="venues-cards"]')[0];

  if (container && window.CUSTOM_SCROLLBAR) {
    $(window.CUSTOM_SCROLLBAR.elements().scrollEventElement).loadMore({ el: container, treshhold: 0 });
  }
}

$(document).on("turbolinks:load", function () {
  setTimeout(() => defaultLayoutLogicInit(), 1000);
});

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

const images = require.context("../images", true);
const imagePath = (name) => images(name, true);
